import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function postOpenBets(data) {
    
    try {
        const response = await serviceContext.post(`${ReportsURL}bets/user/open`, JSON.stringify(data), options);//"openbets", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postOpenBetsCsv(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"openbets/csv", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postOpenBetsPdf(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"openbets/pdf", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };